import React from 'react';
import PropTypes from 'prop-types';
import { REWARD_TYPE } from '../../utils/rewards';
import iconBonus from './icon-bonus.svg';
import iconFood from './icon-food.svg';
import iconFreePlay from './icon-freeplay.svg';
import iconShopping from './icon-shopping.svg';
import iconWindCreek from './icon-windcreek.svg';
import './RewardIcon.css';

const rewardIconMap = {
  [REWARD_TYPE.BONUS_POINTS]: iconBonus,
  [REWARD_TYPE.FOOD_CREDIT]: iconFood,
  [REWARD_TYPE.FREE_PLAY]: iconFreePlay,
  [REWARD_TYPE.SHOPPING_DOLLARS]: iconShopping,
  [REWARD_TYPE.HOTEL_STAY]: iconWindCreek,
  [REWARD_TYPE.DEFAULT]: iconWindCreek
};

const rewardTitleMap = {
  [REWARD_TYPE.BONUS_POINTS]: 'Bonus Points',
  [REWARD_TYPE.FOOD_CREDIT]: 'Food Credit',
  [REWARD_TYPE.FREE_PLAY]: 'Free Play',
  [REWARD_TYPE.SHOPPING_DOLLARS]: 'Shopping Dollars',
  [REWARD_TYPE.HOTEL_STAY]: 'Hotel Stay',
  [REWARD_TYPE.DEFAULT]: 'Reward'
};

function RewardIcon({
  type = REWARD_TYPE.DEFAULT,
  showTitle = false,
  size = 30,
  className
}) {
  let icon = rewardIconMap[type] || rewardIconMap[REWARD_TYPE.DEFAULT];
  let setClass = `reward-icon-${type} reward-icon size-${size}`;
  let titleElement = null;
  if (showTitle) {
    let title = rewardTitleMap[type] || rewardTitleMap[REWARD_TYPE.DEFAULT];
    titleElement = <div className="reward-title">{title}</div>;
    setClass += ' titled-reward-icon';
  }
  if (typeof className !== 'undefined') {
    setClass = className;
  }
  return (
    <div className={setClass}>
      <img alt={`${type} reward`} src={icon} />
      {titleElement}
    </div>
  );
}

RewardIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.number
};

export default RewardIcon;



// WEBPACK FOOTER //
// ./src/components/RewardIcon/index.js